import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type TestimonialsProps = {
  testimonials: Testimonial[];
  eyebrow?: string;
  title?: string;
  subtitle?: string;
  background?: 'white' | 'blush';
};
export function Testimonials({
  testimonials,
  eyebrow = 'Colleague to colleague',
  title = 'What instructors are saying',
  subtitle,
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-white' : 'bg-rose-soft';
  const grid = testimonials.length === 2 ? 'mx-auto max-w-4xl sm:grid-cols-2' : 'sm:grid-cols-2 lg:grid-cols-3';
  return <section aria-label={title} className={`w-full text-navy ${bg}`} data-id="element-293" data-mp="2x11pxyp135tr">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-294" data-mp="2s309zmmwfmmi">
        <div className="text-center" data-id="element-295" data-mp="v96ixwdpvphv">
          <p className="text-sm font-semibold text-lav-deep" data-id="element-296" data-mp="v85a7yk6bf3b">{eyebrow}</p>
          <h2 className="mt-3 font-display text-3xl font-semibold text-navy sm:text-5xl" data-id="element-297" data-mp="qa3pzab0h9q9">{title}</h2>
          {subtitle && <p className="mx-auto mt-4 max-w-2xl text-sm text-navy-soft" data-id="element-298" data-mp="h4wu408ha8h5">{subtitle}</p>}
        </div>

        <div className={`mt-9 grid gap-4 ${grid}`} data-id="element-299" data-mp="m62n7z61vxr7">
          {testimonials.map((item, i) => <figure key={i} className="rounded-3xl bg-white p-5 shadow-card ring-1 ring-paper-dark" data-id="element-300" data-mp="78ttiyt9yhwb" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-301" data-mp="c7wry0er1pvb">
                {item.source ? <>
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-lav-soft" data-id="element-302" data-mp="zwy1jqzbj726">
                      <QuoteIcon className="h-4 w-4 text-lav-deep" aria-hidden="true" data-id="element-303" data-mp="14ur5seh29qzt" />
                    </span>
                    <span className="rounded-full bg-paper px-2.5 py-1 text-[11px] font-semibold text-navy-soft" data-id="element-304" data-mp="q4sbwnwjh1q5">{item.source}</span>
                  </> : <>
                    {item.avatar && <img src={item.avatar} alt={item.author} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-paper-dark" data-id="element-305" data-mp="1nmjwu3ckl24w" />}
                    <span className="flex gap-0.5" aria-label="Five out of five" data-id="element-306" data-mp="1siect8kymttj">
                      {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-peach text-peach" aria-hidden="true" data-id="element-307" data-mp="1ofrd6li1s4ls" />)}
                    </span>
                  </>}
              </div>
              <blockquote className="mt-3 text-[17px] italic leading-relaxed text-navy" data-id="element-308" data-mp="1ekg1kc1xrdi9">“{item.quote}”</blockquote>
              <figcaption className="mt-4 text-xs text-navy-soft" data-id="element-309" data-mp="19qlfj1yuymg0">
                <span className="block text-[13px] font-bold not-italic text-navy" data-id="element-310" data-mp="14tv10j2pbywp">{item.author}</span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}